module.exports = __webpack_public_path__ + "img/window-close.016aa801.svg";